// services/fileService.js
import axios from "axios";
import config from "../config";

// 1) Upload the file (multipart) -> returns filePath
export const uploadFile = async ({
  file,
  processName,
  subProcess,
  fileName,
}) => {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("fileTypeName", processName || "Testing");
  fd.append("subProcess", subProcess || "POC");

  // Debug: Log FormData contents
  // console.log("FormData contents:");
  // for (let [key, value] of fd.entries()) {
  //   console.log(key, value);
  // }

  try {
    // CHANGE: Use absolute backend URL instead of relative path
    const res = await axios.post(
      `${config.backend_Url}/data_models_machine_learning/upload/blob`,
      fd,
    );
    // console.log("Upload response: 59", res);
    return {
      ...res.data,
      filePath: res.data.filePath || res.data.file_path,
    };
  } catch (error) {
    console.error("Upload failed with proxy, trying direct HTTP:", error);
    // Optional: You could add a fallback retry logic here if needed, e.g.,
    // but since we're now using absolute URL, the original proxy catch isn't relevant.
    throw error; // Re-throw to let the thunk handle it
  }
};

// 2) Call the second API using the returned filePath
export const processUploadedFile = async (params = {}) => {
  const rawName = params.file_name || params.filePath || "";
  const file_name =
    typeof rawName === "string" ? rawName.split(/[/\\]/).pop() : "";
  // console.log("Processing file metadata with:", { file_name });
  try {
    const res = await axios.post(
      `${config.backend_Url}/data_models_machine_learning/metadata`,
      { file_name },
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
        },
      }
    );
    // console.log("Process response: fileService", res.data.message);
    return res?.data?.message;
  } catch (error) {
    console.error("Process error:", error);
    throw error;
  }
};

// 3) Calln the third API to apply models
export async function applyModels({
  file_name,
  models,
  dep_variable,
  groupby_columns,
}) {
  // console.log("Applying models with:", {
  //   file_name,
  //   models,
  //   dep_variable,
  //   groupby_columns,
  // });
  try {
    const res = await axios.post(
      `${config.backend_Url}/data_models_machine_learning/anomalies`,
      {
        file_name,
        models,
        dep_variable,
        groupby_columns,
      },
    );
    // console.log("analysis response:", res);
    return res.data;
  } catch (error) {
    console.error("analysis error:", error);
    throw error;
  }
}
